import NavBar from "../components/NavBar";
import ParticleBackground from "../components/ParticleBackground";
import PageTransition from "../components/PageTransition";

export default function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-900 text-white font-sans overflow-x-hidden">
      <div className="bg-gradient-to-r from-blue-700 via-purple-800 to-blue-700 h-2"></div>
      
      <NavBar />
      
      {/* Particle Background */}
      <ParticleBackground />
      
      <div className="relative">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyMTIxMjEiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTYgNjBsLS41NjYtMzAuNzVDMTAuMjc4IDEzLjgyNiAyOS43MjIgNS4xNzUgNjAgNS4xNzV2MzAuNzVjLTMwLjI3OCAwLTQ5LjcyMiA4LjY1MS01NCAyNC4wNzVaIiBvcGFjaXR5PSIuMiIvPjxwYXRoIGQ9Ik0tLjQzNCAyOS4yNWw1NC40MzQgMzBWMjkuMjVILS40MzRaIiBvcGFjaXR5PSIuMiIvPjxwYXRoIGQ9Ik01NCA2MEgzM2MwLTIxIDctMzkgMjEtNTR2NTRaIiBvcGFjaXR5PSIuMiIvPjwvZz48L2c+PC9zdmc+')] opacity-10"></div>
        <main className="p-6 md:p-8 max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto relative">
          <PageTransition>
            {children}
          </PageTransition>
        </main>
      </div>
      
      <footer className="p-6 border-t border-gray-700 text-center text-gray-400 text-sm">
        <div className="max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto">
          <div className="mb-2">
            <span className="inline-block w-8 h-1 bg-blue-500 rounded-full mr-1"></span>
            <span className="inline-block w-3 h-1 bg-purple-500 rounded-full mr-1"></span>
            <span className="inline-block w-1 h-1 bg-indigo-500 rounded-full"></span>
          </div>
          © {new Date().getFullYear()} Eyad Kurd-Misto — All rights reserved
        </div>
      </footer>
    </div>
  );
} 